import { useEffect, useState } from 'react'

import { getLocalStorage } from 'utils/storage/localStorage'

export function useVisualizationType(storageKey: string, defaultStorageKeyValue: string = '') {
  const [visualizationType, setVisualizationType] = useState<string>(defaultStorageKeyValue)

  useEffect(() => {
    const visualizationTypeStorage = getLocalStorage(storageKey)
    if (visualizationTypeStorage) setVisualizationType(visualizationTypeStorage.toString())
  }, [])

  return { visualizationType, setVisualizationType, visualizationTypeStorageKey: storageKey }
}
